import {createContext, useContext} from 'react'
import {triggerReloadInterface} from '../global'

export interface CallTrackingCallTime {
    hour: number,
    minute: number,
    second: number,
}

export interface CallTrackingDashboardData {
    cards: CallTrackingCards
    dataTable: CallTrackingDataTable[]
}

export interface CallTrackingCards {
    callTime: string
    callsSuccess: number
    callReceived: number
    callMissed: number
    callVocal: number
    percentageCallsSuccess: number
    percentageCallsMissed: number
    percentageCallsVocal: number
    numberDays: number
}

export interface CallTrackingDataTable {
    id: number
    called_at: string
    callID: string
    username: string
    cleverphone: string
    transactiontype: transactionEng | transactionFr
    callFrom: string
    subscriber: string
    subscriber_id: number
    transferTo: string
    duration: number
}

export const initialCallTrackingDashboardData: CallTrackingDashboardData = {
    cards: {
        callTime: '',
        callsSuccess: 0,
        callReceived: 0,
        callMissed: 0,
        callVocal: 0,
        percentageCallsSuccess: 0,
        percentageCallsMissed: 0,
        percentageCallsVocal: 0,
        numberDays: 0,
    },
    dataTable: [],
}

export const TransactionBg = (value: transactionFr | transactionEng) => {

    switch (value) {
        case 'Répondu':
            return 'success'
        case 'Manqué':
            return 'danger'
        case 'vocal':
            return 'warning'
        default:
            return ''
    }
}

export const MapTransactionType = (call: CallTrackingDataTable, statusTypes: transactionObject[]): transactionFr | transactionEng => {
    const matchingType = statusTypes.find(type => type.eng === call.transactiontype)
    return matchingType ? matchingType.fr : call.transactiontype
}


// ---------------------------------------------------------------------- V1

export type CallStatisticsSummary = {
    countCallsMissed: number;
    countCallsSuccess: number;
    generalAppelRecu: number;
    percentageCallsMissed: number;
    percentageCallsSuccess: number;
    generalTempsAppel: string;
    has_cleverPhone: boolean
    click_sur_tel: number
    statsCalls: CallStatisticsDetail;
}

export type CallStatisticsDetail = {
    averageCalls: string;
    nbrCalls: string;
    chartLabels: string;
    hours: string;
    totalMissed: string;
    totalSuccess: string;
}

export type transactionEng = 'CALL_INBOUND_ANSWERED' | 'CALL_INBOUND_MISSED' | 'CALL_INBOUND_VOICEMAIL'
export type transactionFr = 'Répondu' | 'Manqué' | 'vocal'

export interface CallLogEntry {
    callFrom: string;
    callID: string;
    called_at: string;
    cleverphone: string;
    created_at: string;
    duration: number;
    id: number;
    transactiontype: transactionEng | transactionFr;
    transferTo: string;
    subscriber_id: number;
    updated_at: string;
    username: string;
    subscriber: string | null
}

export type CallTrackingSummary = {
    callReceived: number;
    callMissed: number;
    callTime: {
        fullTime: string;
        object: {
            hour: string;
            minute: string;
            second: string;
        }
    }
}

export type transactionObject = {
    eng: transactionEng
    fr: transactionFr
}

export const statusTypes: transactionObject[] = [
    {eng: 'CALL_INBOUND_ANSWERED', fr: 'Répondu'},
    {eng: 'CALL_INBOUND_MISSED', fr: 'Manqué'},
    {eng: 'CALL_INBOUND_VOICEMAIL', fr: 'vocal'},
]

export const CallsContext = createContext<triggerReloadInterface | undefined>(undefined)

export const useCalls = () => {
    const context = useContext(CallsContext)
    if (!context) throw new Error('useCalls must be used within CallsProvider')
    return context
}